module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"comments":"Comments from players (only shown to facilitators)"},"fi":{"comments":"Pelaajien kommentit (näkyy vain pelinjohtajalle)"},"sv":{"comments":"Spelarnas kommentarer (endast synlig för spelledare)"},"de":{"comments":"Kommentare von Spielern (werden nur den Spielmanager angezeigt)"},"ko":{"comments":"참여자 댓글 (퍼실리테이터에게만 공개)"}}')
  delete Component.options._Ctor
}
